// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"f423a80e47b596a9","3864":"84e7a7524cd72dca","5371":"506a9e6e6e4b4e4c","6687":"84e7a7524cd72dca"}[chunkId] + ".css";
};